import { Card, Stack, useMediaQuery, useTheme } from '@mui/material';
import { CardsCarousel, LinkCard } from '../../components';
import { LinkListItem, BlockLinkListPalette } from '@dap/sanity/types';

interface Props {
  title: string;
  palette: BlockLinkListPalette;
  links: LinkListItem[];
}

export function LinkList({ title, palette = 'darkGrey', links }: Props) {
  const { breakpoints } = useTheme();
  const enhanced = useMediaQuery(breakpoints.up('md'));
  const cards = links
    ?.map((item) => <LinkCard key={item._key} item={item} palette={palette} />)
    .filter(Boolean);

  if (!cards || cards.length === 0) {
    return null;
  }

  if (enhanced) {
    return (
      <Card>
        <CardsCarousel title={title} cards={cards} />
      </Card>
    );
  }

  return (
    <Card>
      <Stack spacing={2} useFlexGap>
        {cards}
      </Stack>
    </Card>
  );
}
